var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Actions / Icons / Repeat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.4,0.5 L54.4,0.5 C55.5045695,0.5 56.4,1.3954305 56.4,2.5 L56.4,54.5 C56.4,55.6045695 55.5045695,56.5 54.4,56.5 L2.4,56.5 C1.2954305,56.5 0.4,55.6045695 0.4,54.5 L0.4,2.5 C0.4,1.3954305 1.2954305,0.5 2.4,0.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Ticket-Zone-/-Actions",
    transform: "translate(-16.000000, -156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.540037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions-/-Icons-/-Repeat",
    transform: "translate(0.000000, 136.746912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    d: "M2.4,1 C1.57157288,1 0.9,1.67157288 0.9,2.5 L0.9,54.5 C0.9,55.3284271 1.57157288,56 2.4,56 L54.4,56 C55.2284271,56 55.9,55.3284271 55.9,54.5 L55.9,2.5 C55.9,1.67157288 55.2284271,1 54.4,1 L2.4,1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1171717,33.1180555 L21.6828283,33.1180555 L21.6828283,30.3472222 L16.309091,34.0416666 L21.6828283,37.736111 L21.6828283,34.9652777 L37.8040403,34.9652777 L37.8040403,29.4236111 L35.1171717,29.4236111 L35.1171717,33.1180555 Z M21.6828283,23.8819445 L35.1171717,23.8819445 L35.1171717,26.6527778 L40.490909,22.9583334 L35.1171717,19.263889 L35.1171717,22.0347223 L18.9959597,22.0347223 L18.9959597,27.5763889 L21.6828283,27.5763889 L21.6828283,23.8819445 Z",
    id: "Shape",
    fill: "#747474",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/Repeat.5dcd74fe.svg";
export { ForwardRef as ReactComponent };